module.exports = "../static/images/a9d617.png";